import {
  buildSportsCertificatePreviewUrlFromToken,
  buildVoiceNavUrl,
  coerceSportsCertificatePreviewUrl,
  getDefaultVoiceNavApiBaseFromCatalog,
} from '../api/apiConfig'

function sportsNocPayloadFromMetadata(
  md: Record<string, unknown> | undefined,
): Record<string, unknown> | null {
  if (!md) return null
  if (md.sports_noc && typeof md.sports_noc === 'object' && !Array.isArray(md.sports_noc)) {
    return md.sports_noc as Record<string, unknown>
  }
  if (String(md.kind ?? '').trim() === 'sports_noc') {
    return md
  }
  if (String(md.domain ?? '').trim() === 'sports_noc') {
    return md
  }
  return null
}

/**
 * Resolve a browser-openable VoiceNav preview URL from assistant wire metadata.
 * Prefers ``preview_token``; falls back to proxy ``certificate_preview_url`` or raw attachment URL.
 */
export function resolveSportsNocCertificatePreviewUrlFromMetadata(
  md: Record<string, unknown> | undefined,
  apiBaseUrl?: string,
): string | undefined {
  const sn = sportsNocPayloadFromMetadata(md)
  if (!sn) return undefined
  const base = (apiBaseUrl || getDefaultVoiceNavApiBaseFromCatalog()).trim()
  if (!base) return undefined

  const previewToken = String(sn.certificate_preview_token ?? '').trim()
  if (previewToken) {
    const fromToken = buildSportsCertificatePreviewUrlFromToken(previewToken, base)
    if (fromToken) return fromToken
  }

  const certUrl = String(
    sn.certificate_pdf_url ?? sn.file_path ?? sn.certificate_preview_url ?? '',
  ).trim()
  if (!certUrl) return undefined

  const coerced = coerceSportsCertificatePreviewUrl(certUrl, base)
  if (coerced) return coerced

  if (certUrl.startsWith('http://') || certUrl.startsWith('https://')) {
    try {
      const proxy = new URL(buildVoiceNavUrl(base, 'sportsCertificatePreview'))
      proxy.searchParams.set('file_url', certUrl)
      return proxy.toString()
    } catch {
      return undefined
    }
  }
  return undefined
}

export function previewTokenFromSportsNocPreviewUrl(url: string): string {
  try {
    return new URL(url).searchParams.get('preview_token')?.trim() || ''
  } catch {
    return ''
  }
}
